var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.family),function(aFamily,i){return _c('app-card',{key:i,attrs:{"family":aFamily}})}),_c('add-family',{attrs:{"modal-id":_vm.modalIdFamily}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }